import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import PasswordChange from './PasswordChange';
import PasswordReset from './PasswordReset';
import Join from './Join/index';
import IdSearch from './IdSearch/index';
import SideNavBar from '../Common/SideNavBar';
import PrivateRoute from '../Common/PrivateRoute';
import {Layout} from '../Common';

const menus = [
  {path: '/member-service/id-search', name: '아이디 찾기'},
  {path: '/member-service/password-reset', name: '비밀번호 찾기'},
  {path: '/member-service/join', name: '회원가입'},
];

class MemberService extends Component {
  render() {
    return (
      <Layout>
        <SideNavBar title="회원 서비스" menus={menus} />
        <Route path="/member-service/join" component={Join} />
        <Route path="/member-service/id-search" component={IdSearch} />
        <PrivateRoute
          allowedUserStates={['OK', 'WAITING_FOR_CONFIRM']}
          path="/member-service/password-change"
          component={PasswordChange}
        />
        <Route path="/member-service/password-reset" component={PasswordReset} />
      </Layout>
    );
  }
}
export default MemberService;
